import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SbCounterComponent } from "@sports-components/sb-counter/sb-counter.component";
import { SbSportIconComponent } from "@sports-components/sb-sport-icon/sb-sport-icon.component";
import { SportsTitleCasePipe } from "@sports-pipes/index";

@Component({
  selector: "sb-header-with-counter",
  templateUrl: "./sb-header-with-counter.component.html",
  styleUrls: ["./sb-header-with-counter.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule, SportsTitleCasePipe, SbCounterComponent, SbSportIconComponent],
})
export class SbHeaderWithCounterComponent {
  @Input() count?: number;
  @Input() sport?: any;
  @Input() text?: any;
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  haveCount: boolean;
  constructor() {
    this.onClick = new EventEmitter();
  }
  ngOnInit() {
    this.haveCount = this.count > -1;
  }
}
